'use client';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { Button } from '@osmosis/tailwind-ui/components/Button';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import useModal from '../../../hooks/useModal';
import { useUserContext } from '../../../context/UserContext';
import dynamic from 'next/dynamic';

const FeedbackForm = dynamic(() => import('./../FeedbackForm'), { ssr: false });

type Props = {
  title: string;
  learnNodeID: number;
};

/**
 * Render the feedback button.
 */
const FeedbackBlock = ({ title, learnNodeID }: Props) => {
  // Feedback Form Modal
  const modal = useModal();
  const intl = useIntl();
  const { user } = useUserContext();

  if (!user) return null;

  return (
    <>
      {modal.isVisible && (
        <FeedbackForm
          {...modal}
          videoTitle={title}
          nodeID={learnNodeID}
          subjectText={intl.formatMessage(
            {
              id: 'learn.header.feedback_subject_video',
              defaultMessage: 'Subject: Feedback on video -- {videoTitle}',
            },
            { videoTitle: title },
          )}
        />
      )}

      <Box>
        <Button
          onClick={modal.show}
          variant="outline"
          data-testid="learn-page-feedback-btn"
          className={`w-[100%] rounded-[10px]`}
        >
          <FormattedMessage
            defaultMessage="Feedback"
            id="learn.feedback.button_text"
          />
        </Button>
      </Box>
    </>
  );
};

export default FeedbackBlock;
